// Получения данных с типом страниц и их url, для инициализации компонентов в App
export function getAppRoutes(object, prefix = "") {

    const result = [];

    for (const [key, node] of Object.entries(object)) {
        const url = prefix ? `${prefix}/${key}` : key;

        result.push({
            type: node.type,
            url,
            property: node.property
        });

        // Рекурсивный обход для меню
        if (node.type === "menu" && node.links) {
            result.push(...getAppRoutes(node.links, url));
        }
    }
    return result;
}

export function findNodePath(object, targetKey, prefix = "") {
    for (const [key, node] of Object.entries(object)) {
        const currentUrl = prefix ? `${prefix}/${key}` : key;

        // Если нашли нужный ключ
        if (key === targetKey) {
            return {
                title: node.title,
                url: currentUrl,
                property: node.property
            };
        }

        // Если это меню и есть вложенные ссылки - ищем рекурсивно
        if (node.type === "menu" && node.links) {
            const found = findNodePath(node.links, targetKey, currentUrl);
            if (found) return found;
        }
    }

    return null; // Если не нашли
}

// Формирование структуры {"title":"img"}, для изображение в MyRequests
export function getImagesStructure(object, prefix = "") {

    const result = {};

    for (const [key, node] of Object.entries(object)) {
        const url = prefix ? `${prefix}/${key}` : key;

        result[node.title] = node.image

        // Рекурсивный обход для меню
        if (node.type === "menu" && node.links) {
            let beforeResult = getImagesStructure(node.links, url)
            Object.keys(beforeResult).forEach(key=>{
                result[key] = beforeResult[key]
            })
        }
    }

    return result;
}

// Получение данных структуры JSON сайта без вложености с информацией о url
export function flattenStructure(object, prefix = '', result = {}) {

    for (const key in object) {
        const item = object[key]
        const currentUrl = prefix ? `${prefix}/${key}` : key;

        // Создаем новый объект без вложенных links
        const newItem = {
            ...item,
            url: `/${currentUrl}`
        };

        // Удаляем links из нового объекта, чтобы избежать вложенности
        delete newItem.links

        // Добавляем в результат
        result[key] = newItem

        // Рекурсивно обрабатываем вложенные элементы
        if (item.links) {
            flattenStructure(item.links, currentUrl, result)
        }
    }
    return result;
}

// Получение данных о структуре по заданому url
export function findElementByLink(object, findLink, deepLinks=false) {
    const pathParts = findLink.replace(/^\/|\/$/g, '').split('/');
    let currentNode = object;
    let currentPath = [];

    for (const part of pathParts) {
        // Ранний выход, если текущий узел — продукт
        if (currentNode.type === 'product') {
            return {
                type: currentNode.type,
                title: currentNode.title,
                image: currentNode.image,
                enableGlobalFilter: currentNode.enableGlobalFilter,
                configurator: currentNode.configurator, // Добавлено
                property: currentNode.property,
                filter: currentNode.filter,
                seo: currentNode.seo,
                url: [...currentPath, part].join('/'),
                links: currentNode.links ? getLinksParams(currentNode.links, deepLinks) : undefined
            };
        }

        if (!currentNode[part]) {
            return null;
        }

        currentPath.push(part);
        currentNode = currentNode[part];

        // Если это последняя часть пути — возвращаем узел
        if (pathParts[pathParts.length - 1] === part) {
            return {
                type: currentNode.type,
                title: currentNode.title,
                image: currentNode.image,
                enableGlobalFilter: currentNode.enableGlobalFilter,
                configurator: currentNode.configurator, // Добавлено
                property: currentNode.property,
                filter: currentNode.filter,
                seo: currentNode.seo,
                url: currentPath.join('/'),
                links: currentNode.links ? getLinksParams(currentNode.links, deepLinks) : undefined
            };
        }

        // Если у текущего узла нет links, значит путь дальше не уйдёт
        if (!currentNode.links) {
            return null;
        }

        currentNode = currentNode.links;
    }

    return null;
}

// Данные ссылок, без вложенных ссылок
function getLinksParams(links, deep=false){

    const linksObject = {}

    Object.keys(links).forEach(key=>{
        const obj = { ...links[key]};
        if(!deep) {
            delete obj.links;
        }
        linksObject[key] = obj
    })

    return linksObject
}

export function getAllProducts(structure, basePath = '') {
    let products = [];

    // Рекурсивно обходим структуру
    for (const key in structure) {
        if (structure.hasOwnProperty(key)) {
            const node = structure[key];
            const currentPath = basePath ? `${basePath}/${key}` : key;

            if (node.type === 'product') {
                // Если это продукт, добавляем его в список
                products.push({
                    ...node,
                    url: currentPath,
                    // Сохраняем полный путь для навигации
                    nav: currentPath
                });
            } else if (node.links && typeof node.links === 'object') {
                // Если у узла есть ссылки, рекурсивно обходим их
                const nestedProducts = getAllProducts(node.links, currentPath);
                products = products.concat(nestedProducts);
            }

            // Также проверяем, есть ли вложенные объекты помимо links
            if (typeof node === 'object' && node !== null) {
                for (const prop in node) {
                    if (node.hasOwnProperty(prop) &&
                        prop !== 'links' &&
                        typeof node[prop] === 'object' &&
                        node[prop] !== null) {
                        // Рекурсивно обходим другие объектные свойства
                        const nestedProducts = getAllProducts(node[prop], currentPath);
                        products = products.concat(nestedProducts);
                    }
                }
            }
        }
    }

    return products;
}

// Создаем глобальное хранилище всех продуктов
let allProductsCache = null;

// Функция для получения всех продуктов (с кэшированием)
export function getAllProductsCached(structure) {
    if (!allProductsCache) {
        allProductsCache = getAllProducts(structure);
    }
    return allProductsCache;
}

export function findParentWithConfigurator(siteStructure, currentPath) {
    const pathParts = currentPath.replace(/^\/|\/$/g, '').split('/');
    for (let i = pathParts.length - 1; i >= 0; i--) {
        const parentPath = pathParts.slice(0, i).join('/');
        if (!parentPath) continue;
        const parentElement = findElementByLink(siteStructure, parentPath, true);
        if (parentElement && typeof parentElement.configurator === 'string' && parentElement.configurator.length > 0) {
            return {
                hasConfigurator: true,
                configuratorType: parentElement.configurator,
                parentPath,
                parentElement
            };
        }
    }
    return { hasConfigurator: false, configuratorType: null, parentPath: '', parentElement: null };
}